export default __webpack_public_path__ + "static/media/bootstrap.f132cb79.png";